<template>
  <div v-if="document">
    <h2>{{ document.title }} {{ " Content" }}</h2>

    <div
      v-for="(chunk,i) in document.chunks || []"
      :key="chunk.id"
    >
    <h5>{{ "Chunk "+ (i+1) }}</h5>
      <div class="chunk">
        <pre>{{ chunk.content }}</pre>
      </div>
    </div>
  </div>
  <div v-else class="text-center text-danger my-2">
    <b-spinner class="align-middle"></b-spinner>
    <strong>Loading...</strong>
  </div>
</template>

<script>
import { getDocumentById } from "@/core/services/ai.service";

export default {
  name: "AIViewDocument",

  data() {
    return {
      document: null
    };
  },
  props: {
		id: {
			required: true
		}
  },

  created() {
		this.getDocumentView();
	},
  methods: {
    async getDocumentView() {
      try {
        const res = await getDocumentById(this.id);
        this.document = res.data;
        console.log(res.data);
      } catch (error) {
        console.error("Failed to load document", error);
      }
    }
  }
};
</script>

<style scoped>
.chunk {
  background: #f5f5f5;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 6px;
}
</style>
